// Unit conversion helpers for automatic price recalculation on unit change.
// Each entry maps to a base unit and the amount of that base unit per 1 of this unit.
// Two units are convertible ⇔ they share the same base.
export const UNIT_TO_BASE = {
  kg:     { base: "mass",   factor: 1000 }, // 1 kg = 1000 gm
  gm:     { base: "mass",   factor: 1 },
  L:      { base: "volume", factor: 1000 }, // 1 L = 1000 ml
  ml:     { base: "volume", factor: 1 },
  dozen:  { base: "count",  factor: 12 },  // 1 dozen = 12 pcs
  pcs:    { base: "count",  factor: 1 },
  // Non-convertible units below — pack/bag/box/bundle stay unit-locked.
  pack:   { base: "pack",   factor: 1 },
  bag:    { base: "bag",    factor: 1 },
  box:    { base: "box",    factor: 1 },
  bundle: { base: "bundle", factor: 1 },
};

/**
 * Convert a rate given as "amount per fromUnit" into "amount per toUnit".
 * Returns null if the two units are not convertible (different bases).
 * Example: convertRate(100, "kg", "gm") → 0.1
 *          convertRate(1, "gm", "kg") → 1000
 */
export function convertRate(rate, fromUnit, toUnit) {
  if (!rate || !isFinite(rate)) return rate;
  if (fromUnit === toUnit) return rate;
  const f = UNIT_TO_BASE[fromUnit];
  const t = UNIT_TO_BASE[toUnit];
  if (!f || !t || f.base !== t.base) return null;
  // rate is money per fromUnit. Money per baseUnit = rate / f.factor. Money per toUnit = that * t.factor.
  return (rate / f.factor) * t.factor;
}

export function areUnitsConvertible(a, b) {
  if (a === b) return true;
  const f = UNIT_TO_BASE[a], t = UNIT_TO_BASE[b];
  return !!(f && t && f.base === t.base);
}
